<form [formGroup]="form" (ngSubmit)="submit(form)">
    <div class="modal-header">
        <h4 class="modal-title">{{title}}</h4>
    </div>
    <div class="modal-body">
        <label>{{label}}</label>
        <input type="text" class="form-control" id="signature" formControlName="signature"
            placeholder="Enter signature" />
    </div>
    <div class="modal-footer">
        <button type="submit" class="btn btn-success" [disabled]="form?.invalid">Authenticate</button>
        <button type="button" class="btn btn-info" (click)="cancel()">Cancel</button>
    </div>
</form>
